module.exports = __webpack_public_path__ + "assets/img/voice-collect.ef97f30d.png";